<template>
  <div
    class="answer"
    :class="startNode ? 'start-node' : ''"
  >

    <div class="control">
      <div class="title">
        <div
          class="answerTitle"
          v-on:dblclick="openAnswerOptionEditor()"
        >{{ tmp.title }}
        </div>
        <div
          v-if="tmp.isSilence"
          class="silence_or_illegibly silence"
          v-on:dblclick="openAnswerOptionEditor()"
        ><i class="fas fa-comment-slash"></i></div>
        <div
          v-if="tmp.isIllegibly"
          class="silence_or_illegibly illegibly"
          v-on:dblclick="openAnswerOptionEditor()"
        ><i class="fas fa-comment-dots"></i></div>
        <div
          class="answerWords"
          v-on:dblclick="openAnswerOptionEditor()"
          v-show="tmp.tags && tmp.tags.length > 0"
        ><span class="bkt">(</span> <span>{{ wordsStrFormat() }}</span><span class="bkt">)</span></div>
        <div
          class="answerOptionEdit hidden_for_client_automation"
          v-on:click="openAnswerOptionEditor()"
        ><i class="fas fa-edit"></i></div>

        <div class="windowButtons">
          <button
            class="window-small window-change-type"
            :aria-label="$t('scenarios.konstruktor.canvas.answer.windowSizes.smallSize')"
            v-on:click="setWindowSmall(true)"
          >
            <i class="far fa-window-minimize"></i>
          </button>
          <button
            class="window-medium window-change-type"
            :aria-label="$t('scenarios.konstruktor.canvas.answer.windowSizes.mediumSize')"
            v-on:click="setWindowMedium(true)"
          >
            <i class="far fa-window-restore"></i>
          </button>
          <button
            class="window-big window-change-type"
            :aria-label="$t('scenarios.konstruktor.canvas.answer.windowSizes.maxSize')"
            v-on:click="setWindowBig(true)"
          >
            <i class="far fa-window-maximize"></i>
          </button>
          <button
            class="delete hidden_for_client_automation"
            aria-label="delete"
            v-on:click="remove()"
          ></button>
        </div>
      </div>

      <div
        class="wordsEditor"
        v-show="!!editOption"
      >
        <header class="modal-card-head">
          <div class="modal-card-title">
            <div class="control"><input
              v-model="tmp.title"
              class="input"
              placeholder="title"
            /></div>
          </div>
          <button
            class="delete"
            aria-label="close"
            v-on:click="closeAnswerOptionEditor()"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="nonStartNode">
            <div class="control">
              <label class="checkbox isSilence"><input
                type="checkbox"
                v-model="tmp.isSilence"
                class="isSilence checkbox"
              />{{ $t('scenarios.konstruktor.canvas.answer.silence') }}</label>
              <label class="checkbox isIllegibly"><input
                type="checkbox"
                v-model="tmp.isIllegibly"
                class="isIllegibly checkbox"
              />{{ $t('scenarios.konstruktor.canvas.answer.illegibly') }}</label>
            </div>
            <div class="is-block value">
              <label class="is-block">{{ $t('scenarios.konstruktor.canvas.answer.foStatusValueUse') }}: </label>
              <div class="is-block">
                <vb-switch-with-two-labels
                  :model.sync="tmp.useSetValue"
                  :label-left="$t('scenarios.konstruktor.canvas.answer.transcription')"
                  :label-right="$t('scenarios.konstruktor.canvas.answer.indicate')"
                />
                <input
                  :placeholder="$t('scenarios.konstruktor.canvas.answer.stateValue')"
                  v-model="tmp.stateValue"
                  class="input stateValue"
                />
              </div>
            </div>
            <vue-tags v-model="tmp.tags">
              <div
                class="tags-input tags are-large"
                slot-scope="{tag,removeTag,inputEventHandlers,inputBindings }"
              >
                <button
                  type="button"
                  class="button addForAll"
                  v-on:click="addWordsForAllByTitle(tmp)"
                  :title="$t('scenarios.konstruktor.canvas.answer.synonyms.addForAllWithSameTitle')"
                ><i class="fas fa-copy"></i></button>
                <span
                  v-for="tag in tmp.tags"
                  class="tags-input-tag tag is-large"
                >
                  {{ tag }}
                  <button
                    type="button"
                    class="tags-input-remove delete"
                    v-on:click="removeTag(tag)"
                  ></button>
                </span>
                <div class="control">
                  <input
                    class="tags-input-text input"
                    :placeholder="$t('scenarios.konstruktor.canvas.answer.synonyms.addWord') + '...'"
                    v-on="inputEventHandlers"
                    v-bind="inputBindings"
                  />
                </div>
              </div>
            </vue-tags>
          </div>
          <input
            :placeholder="$t('scenarios.konstruktor.canvas.answer.stateQuestion')"
            v-model="tmp.stateQuestion"
            class="input stateQuestion"
          />
        </section>
      </div>

      <div class="tabs is-boxed">
        <ul>
          <li
            class="tab generateFromText"
            data-type="generateFromText"
            :class="answerGenerationType === 'generateFromText' || !answerGenerationType ? 'is-active' : ''"
          >
            <a v-on:click="activateTab('generateFromText')">
              <span>{{ $t('scenarios.konstruktor.canvas.answer.initAudio.fromText') }}</span>
            </a>
          </li>
          <li
            class="tab inputUrls"
            data-type="inputUrls"
            :class="answerGenerationType === 'inputUrls' ? 'is-active' : ''"
          >
            <a v-on:click="activateTab('inputUrls')">
              <span>{{ $t('scenarios.konstruktor.canvas.answer.initAudio.toPutUrl') }}</span>
            </a>
          </li>
          <li
            class="tab uploadFile"
            data-type="uploadFile"
            :class="answerGenerationType === 'uploadFile' ? 'is-active' : ''"
          >
            <a v-on:click="activateTab('uploadFile')">
              <span>{{ $t('scenarios.konstruktor.canvas.answer.initAudio.toUploadFromFile') }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="tabs-content">
        <div
          class="tab-content generateFromText main"
          :class="answerGenerationType === 'generateFromText' || !answerGenerationType  ? 'is-active' : ''"
        >
          <input
            type="hidden"
            class="generationType"
            value="generateFromText"
          />
          <textarea
            v-model="tmp.text"
            class="textarea text"
            v-show="tmp.currentVendor.toLowerCase()!=='google' || tmp.googleSsmlType !== 'ssml'"
          ></textarea>
          <codemirror
            v-model="tmp.text"
            class="text"
            :options="{mode: 'text/html', lineWrapping: true, showCursorWhenSelecting: true}"
            v-show="tmp.currentVendor.toLowerCase()==='google' && tmp.googleSsmlType === 'ssml'"
          />
          <div class="control is-grouped generate_audio_controls">
            <button
              :title="$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')"
              class="button add_parameter generate_audio_control generate_audio_control_first"
              v-on:click="addParameter()"
            ><span>{ + }</span></button>

            <div class="select is-primary vendorControl generate_audio_control">
              <select
                v-model="tmp.currentVendor"
                class="form-control vendor"
                @change="onVendorChange"
              >
                <option value="yandex">Yandex</option>
                <option value="google">Google</option>
                <option value="api-host-kz">Api Host Kz</option>
                <option value="tinkoff">Tinkoff</option>
                <!--                <option value="azure">Azure</option>-->
              </select>
            </div>
            <div class="is-primary speaker generate_audio_control">
              <div
                class="select yandex"
                v-if="tmp.currentVendor.toLowerCase()==='yandex'"
              >
                <select
                  v-model="tmp.currentSpeaker"
                  class="form-control voice"
                >
                  <option
                    v-for="speaker in yandexSpeakerList"
                    :class="speaker.premium ? 'premium' : ''"
                    :value="speaker.value"
                  >
                    {{
                      speaker.label + (speaker.premium ? ("&nbsp;" + "&nbsp;" + "&nbsp;" + "&nbsp;" + "&nbsp;" + "&nbsp;" + "&nbsp;" + "&#x1F451;") : "")
                    }}
                  </option>
                </select>
              </div>
              <div
                class="select api-host-kz"
                v-else-if="tmp.currentVendor.toLowerCase()==='api-host-kz'"
              >
                <select
                  v-model="tmp.currentSpeaker"
                  class="form-control voice"
                >
                  <option
                    v-for="speaker in apiHostSpeakerList"
                    :value="speaker.value"
                  >
                    {{
                      speaker.label
                    }}
                  </option>
                </select>
              </div>
              <div
                class="select api-host-kz"
                v-else-if="tmp.currentVendor.toLowerCase()==='tinkoff'"
              >
                <select
                  v-model="tmp.currentSpeaker"
                  class="form-control voice"
                  @change="onTinkoffSpeakerChange"
                >
                  <option
                    v-for="speaker in tinkoffSpeakerList"
                    :value="speaker.value"
                  >
                    {{
                      speaker.label
                    }}
                  </option>
                </select>
              </div>
              <div
                v-else
                class="google"
              >
                <div
                  class="select"
                  v-if="googleLanguages"
                >
                  <select
                    v-model="tmp.currentLang"
                    class="form-control lang"
                    @change="onGoogleLanguageChange"
                  >
                    <option
                      v-for="language in googleLanguages"
                      :value="language.value"
                    >
                      {{ language.label }}
                    </option>
                  </select>
                </div>
                <input
                  v-else
                  type="text"
                  placeholder="lang"
                  v-model="tmp.currentLang"
                  class="input form-control lang"
                />

                <div
                  class="select"
                  v-if="googleVoicesMapList && googleVoicesMapList[tmp.currentLang]"
                >
                  <select
                    v-model="tmp.currentSpeaker"
                    class="form-control voice"
                  >
                    <option
                      v-for="speaker in googleVoicesMapList[tmp.currentLang]"
                      :value="speaker.value"
                    >
                      {{ speaker.label }}
                    </option>
                  </select>
                </div>
                <input
                  v-else
                  type="text"
                  placeholder="voiceName"
                  v-model="tmp.currentSpeaker"
                  class="input form-control voice"
                />

                <div class="select">
                  <select
                    v-model="tmp.googleSsmlType"
                    class="form-control ssmlType"
                  >
                    <option value="text">
                      {{ $t('scenarios.konstruktor.canvas.answer.initAudio.text') }}
                    </option>
                    <option value="ssml">
                      SSML
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div
              class="select is-primary generate_audio_control"
              v-show="tmp.currentVendor.toLowerCase()==='yandex'"
            >
              <select
                v-model="tmp.currentEmotion"
                class="form-control emotion"
              >
                <option
                  v-for="emotion in emotionList"
                  :value="emotion.value"
                >
                  {{ emotion.label }}
                </option>
              </select>
            </div>
            <div
              class="select is-primary generate_audio_control"
              v-show="tmp.currentVendor.toLowerCase()==='api-host-kz'"
            >
              <select
                v-model="tmp.currentEmotion"
                class="form-control emotion"
              >
                <option
                  v-for="emotion in emotionList"
                  :value="emotion.value"
                >
                  {{ emotion.label }}
                </option>
              </select>
            </div>
            <div
              class="select is-primary generate_audio_control"
              v-if="tmp.currentSpeaker.toLowerCase() === 'alyona'"
              v-show="tmp.currentVendor.toLowerCase()==='tinkoff'"
            >
              <select
                v-model="tmp.currentEmotion"
                class="form-control emotion"
              >
                <option
                  v-for="emotion in emotionAlenaList"
                  :value="emotion.value"
                >
                  {{ emotion.label }}
                </option>
              </select>
            </div>
            <div
              class="select is-primary generate_audio_control"
              v-else-if="tmp.currentSpeaker.toLowerCase() === 'dorofeev'"
              v-show="tmp.currentVendor.toLowerCase()==='tinkoff'"
            >
              <select
                v-model="tmp.currentEmotion"
                class="form-control emotion"
              >
                <option
                  v-for="emotion in emotionDorofeevList"
                  :value="emotion.value"
                >
                  {{ emotion.label }}
                </option>
              </select>
            </div>
            <div class="speed generate_audio_control">
              <slider
                size="small"
                v-bind:value="parseFloat(tmp.currentSpeed)"
                :min="0.5"
                :step="0.1"
                :max="2"
                @change="tmp.currentSpeed = $event"
              ></slider>
              {{ $t('scenarios.konstruktor.canvas.answer.initAudio.speed') }}:&nbsp{{ tmp.currentSpeed }}
            </div>
            <button
              class="button is-primary generate_button generate_audio_control generate_audio_control_last"
              v-on:click="genMainAudio()"
              :disabled="!tmp.text"
            >
              {{ $t('scenarios.konstruktor.canvas.answer.initAudio.generateAudio') }}
            </button>
          </div>
        </div>
        <div
          class="tab-content inputUrls"
          :class="answerGenerationType === 'inputUrls' ? 'is-active' : ''"
        >
          <input
            type="hidden"
            class="generationType"
            value="inputUrls"
          />
          <div
            class="control urls"
            :class="tmp.audio.length === 1 ? 'singleItem' : (tmp.audio.length > 3 ? 'more3_items' :'')"
          >
            <div
              v-for="audio in tmp.audio"
              class="urlForAudio"
            >
              <div v-if="audio.type==='url'">
                <input
                  class="input url"
                  :placeholder="$t('scenarios.konstruktor.canvas.answer.initAudio.putUrl')"
                  v-model="audio.url"
                />
                <i
                  class="fas fa-minus-square fa-3x remove_audio_item"
                  :title="$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveUrl')"
                  v-on:click="removeAudioItem(audio)"
                ></i>
              </div>
              <div v-if="audio.type==='param'">
                <input
                  class="input param"
                  :placeholder="$t('scenarios.konstruktor.canvas.answer.initAudio.putParameterName')"
                  v-model="audio.paramName"
                />
                <i
                  class="fas fa-minus-square fa-3x remove_audio_item"
                  :title="$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveParameter')"
                  v-on:click="removeAudioItem(audio)"
                ></i>
              </div>
            </div>
            <!--              <i class="fas fa-plus-square fa-3x add_url" title="добавить url" v-on:click="addAudioItem('url')"></i>-->
            <div
              style="display: inline"
              class="add_url"
              :title="$t('scenarios.konstruktor.canvas.answer.initAudio.toAddUrl')"
              v-on:click="addAudioItem('url')"
            >
              <i class="fas fa-link fa-2x add_audio_item"></i>
              <i class="fas fa-plus-square fa-3 add_audio_item"></i>
            </div>
            <div
              style="display: inline; margin-left: 20px"
              class="add_param"
              :title="$t('scenarios.konstruktor.canvas.answer.initAudio.toAddParameter')"
              v-on:click="addAudioItem('param')"
            >
              <i class="fas fa-audio-description fa-2x add_audio_item"></i>
              <i class="fas fa-plus-square fa-3 add_audio_item"></i>
            </div>
          </div>
        </div>
        <div
          class="tab-content uploadFile"
          :class="answerGenerationType === 'uploadFile' ? 'is-active' : ''"
        >
          <input
            type="hidden"
            class="generationType"
            value="uploadFile"
          />
          <div class="control uploadFromFileDiv">
            <input
              class="button is-info"
              type="button"
              :value="$t('scenarios.konstruktor.canvas.answer.initAudio.toUploadFromFile')"
              @click="uploadFile()"
            >
            <input
              style="display:none;"
              @input="loadAudio()"
              class="loadFile"
              name="load-audio"
              type="file"
              accept=".wav,.mp3"
            >

            <input
              class="button is-delete"
              type="button"
              :value="$t('scenarios.konstruktor.canvas.answer.initAudio.toRemoveAll')"
              @click="removeAudioItems()"
              v-show="getValidAudioUrlsCount()>0"
            >
          </div>
        </div>
      </div>

      <div
        :class="getAudioSizeClass()"
        class="mainAudioList"
      >
        <div class="audio_list">
          <div
            v-for="audio of tmp.audio"
            class="audio audio_item"
            :class="getAudioClass(audio)"
          >
            <input
              type="hidden"
              class="id"
              v-model="audio.id"
            />
            <div v-if="audio.url || audio.paramName">
              <input
                type="hidden"
                v-model="audio.number"
                class="number"
              >
              <audio
                v-if="audio.type==='url'"
                :ref="'onPlayer'"
              >
                <source v-bind:src="audio.url">
                {{
                  $t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')
                }}
              </audio>
              <audio-player
                v-if="audio.type==='url'"
                :file="audio.url"
                :onLoad="function(data) {  audio.duration = data.duration  }"
              />
              <input
                type="hidden"
                v-if="audio.type==='param'"
                v-model="audio.paramName"
                class="audioParam"
              >
              <input
                type="hidden"
                v-if="audio.type==='url'"
                v-model="audio.duration"
                class="audioDuration"
              >
            </div>
          </div>
        </div>
        <div style="clear:both"/>
      </div>

      <div :class="getAudioSizeClass()">
        <button
          class="audioConfig hidden_for_client_automation"
          :aria-label="$t('scenarios.konstruktor.canvas.answer.audioConfig')"
          v-on:click="showPlaySourceConfig = !showPlaySourceConfig"
        >
          <i class="fas fa-cog"></i>
        </button>
      </div>

      <div
        class="playSourceConfig"
        v-show="!!showPlaySourceConfig"
      >
        <div class="modal-card">
          <header class="modal-card-head">
            <div class="modal-card-title">
              <div class="control"><label class="label">{{ $t('common.settings') }} SpeechCollect</label></div>
            </div>
            <button
              class="delete"
              aria-label="close"
              v-on:click="showPlaySourceConfig = false"
              :title="$t('common.actions.close')"
            ></button>
          </header>
          <section class="modal-card-body">
            <div class="control">
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th>{{ $t('common.key') }}</th>
                    <th>{{ $t('common.value') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="">
                    <td class="key">
                      <span>{{ $t('scenarios.konstruktor.canvas.recognition.recognitionDriver') }}</span>
                    </td>
                    <td class="value">
                      <div class="control">
                        <div class="select">
                          <select
                            v-model="tmp.recognitionDriver"
                            class="form-control recognitionDriver"
                          >
                            <option value="">{{ $t('common.default') }}</option>
                            <option value="google">Google</option>
                            <option value="yandex">Yandex</option>
                            <option value="3itech">3-itech(KZ)</option>
                          </select>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="searchStrategyTr">
                    <td class="key">
                      <span>Search Strategy</span>
                    </td>
                    <td class="value">
                      <div class="control">
                        <div class="select">
                          <select
                            v-model="tmp.searchStrategy"
                            class="searchStrategy"
                          >
                            <option title='Используется как стратегия по умолчанию

      Проверяет на наличие синонимов внутри всего распознанного текста

      Рекомендуется:
      1) Для длинных меню, где абонент может перебивать робота
      2) Для вопросов, у которых нет пересекающихся синонимов, например:
           - Синоним ОДОБРЕНИЕ: "да", "ага", "конечно"
           - Синоним ОТРИЦАНИЕ: "нет", "да нет наверное", "ни за что"
           Если абонент начнет говорить фразу "да нет наверное" (фактически по этой фразе робот должен отнести ответ к ветке ОТРИЦАНИЕ)
           Но этого не произойдет, потому что как только робот услышит "да", он среагирует на него и в результат запишет ОДОБРЕНИЕ

      Не рекомендуется:
      - Для NPS - сценариев, у которых среди вариантов ответа присутствуют цифры больше 9, потому что если абонент
      ответит десять (некоторые вендоры распознавания вернут это значение в виде цифры), робот получит для обработки
      строку "10". В таком случае стратегия в ответе абонента среагирует на "1" и запишет её в результат.'
                                    value="CONTAINS">contains
                            </option>
                            <option title='Стратегия реагирует на полное совпадение распознанного текста с синонимами.

     Рекомендуется:
     - Для вопросов, в которых ожидается конкретная фраза. Хорошо подойдет для вопросов с большим количеством не пересекающихся синонимов.'
                                    value="EQUALS">equals
                            </option>
                            <option title='Стратегия разбивает строку на отдельные слова и сравнивает со списком синонимов
      (фразы-синонимы должны быть СТРОГО из одного слова )

      Рекомендуется:
      - Для NPS-вопросов - сценариев, например, оценка какого-либо сервиса по цифровой шкале.

      Не рекомендуется:
      - Для вопросов, у которых фразы-синонимы состоят более чем из одного слова - робот их проигнорирует'
                                    value="EQUALS_WITH_RECOGNITION_SPLITTING">equals with recognition splitting
                            </option>
                            <option title='Стратегия реагирует на полное совпадение распознанного текста с синонимами.

      Рекомендуется:
      - Для вопросов, в которых ожидается конкретная фраза. Хорошо подойдет для вопросов с большим количеством синонимов.
      Пересекаются синонимы в разных ветках или нет, для этой стратегии не важно.' value="EQUALS_FULL_SPEECH">equals
                              full speech
                            </option>
                          </select>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="key">
                      <span>Timeout</span>
                    </td>
                    <td class="value">
                      <input
                        v-model="tmp.timeout"
                        class="input timeout"
                        type="number"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="key">
                      <span>Start Collect Before PlayEnd</span>
                    </td>
                    <td class="value">
                      <input
                        v-model="tmp.startCollectBeforePlayEnd"
                        class="input startCollectBeforePlayEnd"
                        type="number"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="key">
                      <span>Waiting Input Timeout</span>
                    </td>
                    <td class="value">
                      <input
                        v-model="tmp.waitingInputTimeout"
                        class="input waitingInputTimeout"
                        type="number"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="key">
                      <span>Silence After Speech Timeout</span>
                    </td>
                    <td class="value">
                      <input
                        v-model="tmp.silenceAfterSpeechTimeout"
                        class="input silenceAfterSpeechTimeout"
                        type="number"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="key">
                      <span>Delay Before Collect</span>
                    </td>
                    <td class="value">
                      <input
                        v-model="tmp.delayBeforeCollect"
                        class="input delayBeforeCollect"
                        type="number"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="key">
                      <span>Simulated Delay Millis</span>
                    </td>
                    <td class="value">
                      <input
                        v-model="tmp.simulatedDelayMillis"
                        class="input simulatedDelayMillis"
                        type="number"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Cleave from 'vue-cleave'
import AudioPlayer from '../../../components/audio-player.vue'
import {mapGetters} from 'vuex'
import {Collapse, Item as CollapseItem} from 'vue-bulma-collapse'
import Modal from '../ModalAudio'
import Slider from 'vue-bulma-slider'
import BaseComponent from '../BaseComponent'
import VueTags from 'vue-tags'
import VbSwitch from 'vue-bulma-switch'
import VbSwitchWithTwoLabels from '../../components/VbSwitchWithTwoLabels'
import {googleLanguages as importedGoogleLanguages, googleVoicesMapList as importedGoogleVoices} from './googleVoices'
import {codemirror} from 'vue-codemirror'
import 'codemirror/mode/htmlmixed/htmlmixed.js'

const audioGeneratorApi = '/audios/generate'
// const audioGeneratorApi = '/audios/generate'
const audioUploadApi = '/audios/saveNew'
const audioDeleteApi = '/audios'

export default {
  extends: BaseComponent,
  props: ['startNode', 'answerId', 'answerTitle', 'answerStateQuestion', 'answerTranskribValue', 'answerStateValue', 'answerWords', 'answerText', 'answerAudio', 'answerGenerationType', 'answerIsSilence', 'answerIsIllegibly', 'answerSearchStrategy', 'answerRecognitionDriver', 'answerTimeout', 'answerStartCollectBeforePlayEnd', 'answerStartCollectBeforePlayEnd', 'answerWaitingInputTimeout', 'answerSilenceAfterSpeechTimeout', 'answerDelayBeforeCollect', 'remove', 'addWordsForAllByTitle', 'answerCurrentVendor', 'answerCurrentLang', 'answerCurrentSpeaker', 'answerGoogleSsmlType', 'answerCurrentEmotion', 'answerCurrentSpeed', 'answerRepeat', 'answerRepeatFail', 'setNodeHeight', 'setWindowSmall', 'setWindowMedium', 'setWindowBig', 'getScenarioLang', 'answerSimulatedDelayMillis'],
  components: {
    VbSwitchWithTwoLabels,
    Modal,
    Cleave,
    AudioPlayer,
    Collapse,
    CollapseItem,
    Slider,
    VueTags,
    VbSwitch,
    codemirror
  },
  computed: {
    ...mapGetters([
      'loadedScenario',
      'loggedId',
      'loggedUser',
      'authenticationToken'
    ])
  },
  methods: {
    activateTab(tabClass) {
      let tabs = this.$el.querySelectorAll('.tab, .tab-content')
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('is-active')
      }
      tabs = this.$el.querySelectorAll('.' + tabClass)
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.add('is-active')
      }

      this.activeTab = 'main'
    },
    getScenarioId() {
      return document.querySelector('#Konstruktor .scenarioId').value
    },
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },
    changeRoute: function (e) {
      this.$router.push({path: '/scenarios' + e.target.value})
    },

    addParameter() {
      this.tmp.text = (this.tmp.text || '') + '{parameterName}'
    },

    onVendorChange() {
      if (this.tmp.currentVendor === 'google') {
        this.tmp.currentSpeaker = (this.googleVoicesMapList && this.googleVoicesMapList[this.tmp.currentLang]) ? this.googleVoicesMapList[this.tmp.currentLang][0].value : ''
      } else if (this.tmp.currentVendor === 'api-host-kz') {
        this.tmp.currentSpeaker = '2018'
      }else if (this.tmp.currentVendor === 'tinkoff') {
        this.tmp.currentSpeaker = 'alyona'
        this.tmp.currentEmotion = 'funny'
      }  else {
        this.tmp.currentSpeaker = 'oksana'
      }
    },
    onGoogleLanguageChange() {
      this.tmp.currentSpeaker = (this.googleVoicesMapList && this.googleVoicesMapList[this.tmp.currentLang]) ? this.googleVoicesMapList[this.tmp.currentLang][0].value : ''
    },
    onTinkoffSpeakerChange() {
      if (this.tmp.currentSpeaker === 'alyona') {
        this.tmp.currentEmotion = 'funny'
      }
      if (this.tmp.currentSpeaker === 'dorofeev') {
        this.tmp.currentEmotion = 'neutral'
      }
    },
    genAudioRequest(text) {
      let request
      if (this.tmp.currentVendor === 'google') {
        request = this.genAudioRequestByGoogle(text)
      } else if (this.tmp.currentVendor === 'api-host-kz') {
        request = this.genAudioRequestByApiHost(text)
      }else if (this.tmp.currentVendor === 'tinkoff') {
        request = this.genAudioRequestByTinkoff(text)
      } else {
        request = this.genAudioRequestByYandex(text)
      }
      return request
    },
    genAudioRequestByYandex(text) {
      let request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this.tmp.currentSpeaker,
          'emotion': this.tmp.currentEmotion,
          'speed': this.tmp.currentSpeed
        },

        'vendor': 'yandex'
      }
      console.log(JSON.stringify(request))
      return request
    },
    genAudioRequestByApiHost(text) {
      let request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this.tmp.currentSpeaker,
          'emotion': this.tmp.currentEmotion,
          'speed': this.tmp.currentSpeed
        },

        'vendor': 'api-host-kz'
      }
      console.log(JSON.stringify(request))
      return request
    },genAudioRequestByTinkoff(text) {
      let request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'speaker': this.tmp.currentSpeaker,
          'emotion': this.tmp.currentEmotion,
          'speed': this.tmp.currentSpeed
        },

        'vendor': 'tinkoff'
      }
      console.log(JSON.stringify(request))
      return request
    },
    genAudioRequestByGoogle(text) {
      let request = {
        'commonParameters': {
          'client': this.getScenarioId(),
          'scenario': this.getScenarioId(),
          'audioName': this._props.name,
          'text': text
        },

        'vendorSpecificParameters': {
          'languageCode': this.tmp.currentLang,
          'voiceName': this.tmp.currentSpeaker,
          'speakingRate': this.tmp.currentSpeed
        },

        'vendor': 'google'
      }

      // 'text': (this.tmp.googleSsmlType !== 'ssml') ? text : '',
      // 'ssml': (this.tmp.googleSsmlType === 'ssml') ? text : '', TODO support ssml

      console.log(JSON.stringify(request))
      return request
    },
    securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      }
    },
    getValidAudioUrlsCount() {
      let validUrlCount = 0
      let audioList
      audioList = this.tmp.audio
      if (audioList && audioList.length) {
        for (let i = 0; i < audioList.length; i++) {
          if (audioList[i].url && audioList[i].type === 'url') {
            validUrlCount++
          }
        }
      }
      return validUrlCount
    },
    getAudioSizeClass() {
      let validUrlCount = this.getValidAudioUrlsCount()
      return validUrlCount ? (validUrlCount === 1 ? 'size_1' : (validUrlCount > 2 ? 'size_2 size_more_2' : 'size_2')) : 'empty'
    },
    getAudioClass(audio) {
      let classStr = '' + audio.type
      if (audio.type === 'url' && audio.urlIndex) {
        if (audio.urlIndex % 2) {
          classStr += (' first_url')
        } else {
          classStr += (' second_url')
        }
      }
      return classStr
    },
    removeAudioItems() {
      for (let i = 0; i < this.tmp.audio.length; i++) {
        if (this.tmp.audio[i].id) {
          this.deleteAudioFromBase(this.tmp.audio[i].id)
        }
      }
      this.tmp.audio = [{type: 'url', number: 1}]
      // this.deleteAudiosFromBase()
    },
    removeAudioItem(audio) {
      let filtered = this.tmp.audio.filter(function (value, index, arr) {
        return value !== audio
      })
      this.tmp.audio = filtered
      if (audio.id) {
        this.deleteAudioFromBase(audio.id)
      }
    },
    addAudioItem(type) {
      let maxNumber = 1
      for (let i = 0; i < this.tmp.audio.length; i++) {
        if ((this.tmp.audio[i].number || 0) > maxNumber) {
          maxNumber = this.tmp.audio[i].number
        }
      }
      this.pushAudio({
        number: maxNumber + 1,
        type: type
      })
    },
    pushAudio(audio) {
      let audioList
      audioList = this.tmp.audio
      audioList.push(audio)
      audioList.sort((a, b) => ((a.number || 0) > (b.number || 0)) ? 1 : -1)
      this.setAudiosUrlIndex(audioList)
    },
    setAudiosUrlIndex(audioList) {
      if (audioList && audioList.length) {
        let urlIndex = 0
        for (let i = 0; i < audioList.length; i++) {
          if (audioList[i].type === 'url') {
            urlIndex++
            audioList[i].urlIndex = urlIndex
          }
        }
      }
    },
    getAudioGeneratorUrl() {
      return audioGeneratorApi
    },
    genAudio(texts) {
      let index = 0
      let that = this

      function requestSuccessCallback(data, number) {
        if (that.tmp.onLoading) {
          that.pushAudio({
            id: data,
            number: number,
            type: 'url',
            url: `/audios/${data}.wav`
          })
          index++
          if (index === texts.length) {
            that.tmp.onLoading = false
            that._props.setNodeHeight(that.getValidAudioUrlsCount())
          }
        }
      }

      function requestFailCallback(error, i) {
        console.log(error)
        that.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.errorLoadAudio)
        that.tmp.onLoading = false
        if (!i) {
          that._props.setNodeHeight(that.getValidAudioUrlsCount())
        }
      }

      if (!this.getScenarioId()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.beforeGenerateAudioYouShouldSaveScenario)
      } else {
        this.tmp.onLoading = true
        this.removeAudioItems()
        this.tmp.audio = []
        const headers = {headers: this.securityHeaders()}

        for (let i = 0; i < texts.length; i++) {
          if (texts[i].type === 'text') {
            const request = this.genAudioRequest(texts[i].text)
            this.$http.post(this.getAudioGeneratorUrl(), request, headers)
              .then(response => {
                requestSuccessCallback(response.data, i)
              })
              .catch(error => {
                requestFailCallback(error, i)
                // if (error || requestFailCallback) {
                //   requestSuccessCallback('111' + i, i)
                // }
              })
          } else {
            that.pushAudio({
              number: i,
              type: 'param',
              paramName: texts[i].paramName
            })
            index++
          }
        }
      }
    },
    genMainAudio() {
      let texts = this.parseText(this.tmp.text)
      this.genAudio(texts, 'main')
    },
    parseText(pText) {
      let fullText = ((pText || '') + '').trim()
      let texts = []
      let symbol = '{'
      let finder = 'open_param'

      while (fullText.length) {
        let startParam = fullText.indexOf(symbol)
        if (startParam > -1) {
          let text = fullText.substr(0, startParam)
          if (text) {
            if (finder === 'open_param') {
              let textPart = text.replace('{', '').replace('}', '').trim()
              if (textPart) {
                if (/\d/.test(textPart) || textPart.match(/[a-z]/i) != null || textPart.match(/[а-я]/i) != null) {
                  texts.push({
                    type: 'text',
                    text: textPart
                  })
                }
              }
            } else {
              texts.push({
                type: 'param',
                paramName: text.replace('{', '').replace('}', '')
              })
            }
          }
          finder = finder === 'open_param' ? 'close_param' : 'open_param'
          symbol = symbol === '{' ? '}' : '{'
          fullText = fullText.substr(startParam + 1)
        } else {
          if (fullText) {
            texts.push({
              type: 'text',
              text: fullText
            })
          }
          fullText = ''
        }
      }
      return texts
    },
    uploadFile() {
      if (!this.getScenarioId()) {
        this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.beforeUploadFileYouShouldSaveScenario)
      } else {
        this.$el.getElementsByClassName('loadFile')[0].click()
      }
    },
    loadAudio() {
      let that = this
      const input = this.$el.getElementsByClassName('loadFile')[0]
      if (input.files && input.files[0]) {
        if (!this.getScenarioId()) {
          this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.beforeLoadAudioYouShouldSaveScenario)
        } else {
          this.$http.post(audioUploadApi, this.prepareMultipartAudio(input.files[0], this.tmp.id, this.getScenarioId(), this.getScenarioId()), this.prepareUploadHeaders())
            .then(response => {
              if (that.tmp.audio && that.tmp.audio.length === 1 && that.tmp.audio[0].type === 'url' && !that.tmp.audio[0].url) {
                that.tmp.audio = []
              }
              that.tmp.audio.push({
                id: response.data,
                number: 1,
                type: 'url',
                url: `/audios/${response.data}.wav`
              })
            })
            .catch(error => {
              console.log(error)
              this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].notifications.errorLoadAudio)
              // if (that.tmp.audio && that.tmp.audio.length === 1 && that.tmp.audio[0].type === 'url' && !that.tmp.audio[0].url) {
              //   that.tmp.audio = []
              // }
              // that.tmp.audio.push({
              //   number: 1,
              //   type: 'url',
              //   url: `/audios/111.wav`
              // })
            })
        }
      }
    },
    // deleteAudiosFromBase() {
    //   if (this.getScenarioId()) {
    //     this.$http.delete(`${audioDeleteApi}/byScenario/${this.getScenarioId()}`, {headers: this.prepareUploadHeaders()})
    //   }
    // },
    deleteAudioFromBase(audioId) {
      if (this.getScenarioId()) {
        this.$http.delete(`${audioDeleteApi}/${audioId}`, {headers: this.prepareUploadHeaders()})
      }
    },
    prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      const audioFormData = new FormData()
      audioFormData.append('file', audioFile)
      audioFormData.append('name', audioName)
      audioFormData.append('client', audioClient)
      audioFormData.append('scenario', audioScenario)
      return audioFormData
    },
    prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      }
    },

    confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'))
      this.closeModal()
    },

    showAllAudios() {
      this.allAudios = true
    },
    closeAllAudios() {
      this.allAudios = false
    },

    openAnswerOptionEditor(elem) {
      // if (!this._props.startNode) {
      this.editOption = true
      // }
    },
    closeAnswerOptionEditor() {
      this.editOption = false
    },

    wordsStrFormat() {
      if (this.tmp.tags) {
        let tagsStr = this.tmp.tags.join(', ')
        if (tagsStr.length > 44 - (this.tmp.title || '').length) {
          return tagsStr.substr(0, 41 - (this.tmp.title || '').length) + '...'
        } else {
          return tagsStr
        }
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      tmp: {
        audio: [],
        tags: [],
        title: '',
        stateValue: '',
        useSetValue: true,
        stateQuestion: '',
        isSilence: false,
        isIllegibly: false,
        generationAudioType: 'generateFromText',
        searchStrategy: 'EQUALS',
        recognitionDriver: '',
        simulatedDelayMillis: 0,
        timeout: '',
        startCollectBeforePlayEnd: '',
        waitingInputTimeout: '',
        silenceAfterSpeechTimeout: '',
        delayBeforeCollect: '',

        text: '',
        onLoading: false,
        currentLang: '',

        currentSpeaker: 'oksana',
        currentVendor: 'yandex',
        currentEmotion: 'good',
        currentSpeed: 1,

        googleSsmlType: 'text'
      },
      apiHostSpeakerList: [
        {
          value: '2018',
          label: 'Асель'
        },
        {
          value: '2019',
          label: 'Асель (TEL)'
        }

      ],
      tinkoffSpeakerList: [
        {
          value: 'alyona',
          label: 'Алена'
        },
        {
          value: 'dorofeev',
          label: 'Дорофеев'
        },
        {
          value: 'maxim',
          label: 'Максим'
        }


      ],
      yandexSpeakerList: [
        {
          value: 'jane',
          label: 'Жанна'
        },
        {
          value: 'oksana',
          label: 'Оксана'
        },
        {
          value: 'alyss',
          label: 'Алиса'
        },
        {
          value: 'omazh',
          label: 'Маша'
        },
        {
          value: 'zahar',
          label: 'Захар'
        },
        {
          value: 'ermil',
          label: 'Эрмиль'
        },
        {
          value: 'alena',
          label: 'Алёна',
          premium: true
        },
        {
          value: 'filipp',
          label: 'Филипп',
          premium: true
        }
      ],
      googleVoicesMapList: importedGoogleVoices,
      googleLanguages: importedGoogleLanguages,
      // currentEmotion: 'neutral',
      emotionList: [
        {
          value: 'good',
          label: 'радостное'
        },
        {
          value: 'neutral',
          label: 'нейтральное'
        },
        {
          value: 'evil',
          label: 'плохое'
        }
      ],
      emotionAlenaList: [
        {
          value: '',
          label: 'обычное'
        },
        {
          value: 'sad',
          label: 'грустное'
        },
        {
          value: 'funny',
          label: 'веселое'
        },
        {
          value: 'flirt',
          label: 'флирт'
        }
      ],
      emotionDorofeevList: [
        {
          value: 'neutral',
          label: 'обычное'
        },
        {
          value: 'drama',
          label: 'драма'
        },
        {
          value: 'comedy',
          label: 'комедия'
        },
        {
          value: 'info',
          label: 'инфо'
        },
        {
          value: 'tragedy',
          label: 'трагедия'
        }
      ],
      editOption: false,
      allAudios: false,
      showPlaySourceConfig: false,
      activeTab: ''
    }
  },
  mounted() {
    this.tmp.audio = this._props.answerAudio
    if (!this.tmp.audio || !this.tmp.audio.length) {
      this.tmp.audio = [{type: 'url', number: 1}]
    }
    this.setAudiosUrlIndex(this.tmp.audio)

    this.tmp.title = '' + (this._props.answerTitle || '')
    this.tmp.id = '' + (this._props.answerId || '')
    this.tmp.stateQuestion = '' + (this._props.answerStateQuestion || '')
    this.tmp.stateValue = '' + (this._props.answerStateValue || '')
    this.tmp.useSetValue = !this._props.answerTranskribValue

    let tags = []
    if (this._props.answerWords) {
      for (let i = 0; i < this._props.answerWords.length; i++) {
        tags.push('' + this._props.answerWords[i])
      }
    }
    this.tmp.tags = tags
    this.tmp.text = '' + (this._props.answerText || '')

    this.tmp.isSilence = this._props.answerIsSilence
    this.tmp.isIllegibly = this._props.answerIsIllegibly

    this.tmp.searchStrategy = this._props.answerSearchStrategy || 'EQUALS'
    this.tmp.recognitionDriver = this._props.answerRecognitionDriver || ''
    this.tmp.timeout = this._props.answerTimeout
    this.tmp.startCollectBeforePlayEnd = this._props.answerStartCollectBeforePlayEnd
    this.tmp.waitingInputTimeout = this._props.answerWaitingInputTimeout
    this.tmp.silenceAfterSpeechTimeout = this._props.answerSilenceAfterSpeechTimeout
    this.tmp.delayBeforeCollect = this._props.answerDelayBeforeCollect

    this.tmp.generationAudioType = this._props.answerGenerationType || this.tmp.generationAudioType

    this.tmp.currentVendor = this._props.answerCurrentVendor || this.tmp.currentVendor
    this.tmp.currentLang = this._props.answerCurrentLang || this.tmp.currentLang
    if (!this.tmp.currentLang) {
      this.tmp.currentLang = this._props.getScenarioLang()
    }

    this.tmp.currentSpeaker = this._props.answerCurrentSpeaker || this.tmp.currentSpeaker
    this.tmp.currentEmotion = this._props.answerCurrentEmotion || this.tmp.currentEmotion
    this.tmp.currentSpeed = this._props.answerCurrentSpeed || this.tmp.currentSpeed
    this.tmp.simulatedDelayMillis = this._props.answerSimulatedDelayMillis || this.tmp.simulatedDelayMillis
    this.tmp.googleSsmlType = this._props.answerGoogleSsmlType || this.tmp.googleSsmlType
  }
}

</script>


<style lang="scss" scoped>
@import "~bulma/sass/utilities/mixins";
@import "~codemirror/lib/codemirror.css";

.spinner {
  margin-right: 5px;
}

.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}

.custom-file-input::before {
  content: "Select some files";
  display: inline-block;
  background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
}

.custom-file-input:hover::before {
  border-color: black;
}

.custom-file-input:active::before {
  background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

p {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
}

.answer .title {
  font-size: 16px;
  white-space: nowrap;
  text-align: left;
  height: 32px;
  margin-bottom: 0;
  display: inline;
}

.answer:hover {
  cursor: pointer;
}

/*.answer.start-node .title .answerOptionEdit  {*/
/*  display: none;*/
/*}*/
.answer .title .answerOptionEdit {
  display: inline;
}

.answer .title div {
  display: inline;
}

.answer .title .answerTitle {
  padding-right: 16px;
  font-size: 18px;
  font-weight: bold;
}

.answer.start-node textarea {
  height: 82px;
}

.answer textarea {
  height: 74px;
  min-height: 70px;
  resize: none;
}

.answer .speed {
  /*display: inline-block;*/
  /*margin-top: 10px;*/
  margin-left: 8px;
  margin-top: 13px;
  /*display: none;*/
}

.message-body .inner {
  background-color: whitesmoke;
}

.message-header {
  margin-bottom: 0;
}

.answerOptionEdit {
  display: inline;
  margin-left: 5px;
}

.answerOptionEdit:hover {
  cursor: pointer;
}

.start-node .wordsEditor .nonStartNode {
  display: none;
}

.answerOption .modal-card-head .modal-card-title div.control {
  margin-right: 16px;
}

.modal-card-body .tags .tag {
  margin-bottom: 12px;
  margin-left: 1px;
  margin-right: 1px;
  /*font-size: 16px;*/
}

/*.generate_audio_controls {*/
/*  float:right;*/
/*}*/
.generate_audio_control.generate_button span {
  margin-right: 3px !important;
}

.generate_audio_control {
  font-size: 14px;
}

.generate_audio_controls .generate_audio_control {
  margin-left: 2px;
  margin-right: 2px;
}

.generate_audio_controls .generate_audio_control.generate_audio_control_first {
  margin-left: 0;
  margin-right: 10px;
  /*float:left;*/
}

.generate_audio_controls .generate_audio_control.generate_audio_control_last {
  margin-left: 2px;
  margin-right: 0;
}

/*.generate_audio_controls .generate_audio_control.speaker select option.premium {*/
/*  background: rgba(200, 197, 68, 0.3);*/
/*}*/
/*.generate_audio_controls .generate_audio_control.speaker select option.premium:after {*/
/*  content: " ";*/
/*  display: inline-block;*/

/*}*/

.generate_audio_controls .generate_audio_control.speaker .yandex select {
  width: 146px;
}

.generate_audio_controls .generate_audio_control.speaker .yandex select option {
  width: 146px;
}

.generate_audio_controls .generate_audio_control select.emotion {
  width: 146px;
}

.generate_audio_controls .generate_audio_controlselect.emotion option {
  width: 146px;
}

.generate_audio_controls .generate_audio_control.speaker .google select.lang {
  max-width: 119px;
}

.generate_audio_controls
.generate_audio_control.speaker
.google
select.lang
option {
  max-width: 119px;
}

.generate_audio_controls .generate_audio_control.speaker .google select.voice {
  max-width: 174px;
}

.generate_audio_controls
.generate_audio_control.speaker
.google
select.voice
option {
  max-width: 174px;
}

.generate_audio_controls .generate_audio_control.speaker input {
  max-width: 200px;
}

.generate_audio_controls .generate_audio_control.speaker input.lang {
  max-width: 60px;
}

.generate_audio_controls .generate_audio_control.speaker input.voice {
  max-width: 130px;
}

.text {
  margin-top: 10px;
}

.title .delete {
  /*float: right;*/
  background-color: indianred;
  margin-left: 16px;
}

.windowButtons {
  float: right;
}

.windowButtons button.window-change-type {
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  border: none;
  border-radius: 290486px;
  cursor: pointer;
  display: inline-block;
  font-size: 1rem;
  height: 20px;
  outline: none;
  position: relative;
  vertical-align: center;
  width: 20px;
  background-color: unset;
  color: #262626;
}

.windowButtons button.window-change-type:hover {
  color: black;
  font-weight: bold;
}

.windowButtons button.window-change-type.window-big {
  display: none;
}

.small .windowButtons button.window-change-type.window-big {
  display: inline-block;
}

.medium .windowButtons button.window-change-type.window-big {
  display: inline-block;
}

.small .windowButtons button.window-change-type.window-small {
  display: none;
}

.medium .windowButtons button.window-change-type.window-medium {
  display: none;
}

/*.windowButtons button.window-change-type {*/
/*  display:none*/
/*}*/

.start-node .title .delete {
  display: none;
}

.add_parameter span {
  margin-left: 3px;
}

.audio_list {
  margin-top: 5px;
  /*height: 31px;*/
}

.audio_list .audio {
  display: inline-table;
}

.audio_list .audio.audio_item.param {
  display: none !important;
}

.size_1 .audio_list .audio {
  width: 100%;
}

.size_2 .audio_list .audio {
  max-width: 48%;
}

/*.size_more_2 .audio_list .audio {*/
/*  !*display:none;*!*/
/*}*/
.size_more_2 .audio_list .audio.url.first_url,
.size_more_2 .audio_list .audio.url.second_url {
  display: inline-block;
}

.size_2 .audio_list .audio.url.first_url {
  float: left;
  margin-right: 32px;
}

.medium .size_2 .audio_list .audio.url.first_url,
.small .size_2 .audio_list .audio.url.first_url {
  float: none;
  margin-right: 0;
}

.size_2 .audio_list .audio.url {
  float: right;
}

.medium .size_2 .audio_list .audio.url,
.small .size_2 .audio_list .audio.url {
  float: none;
}

.allAudiosButton {
  display: none;
}

.size_more_2 .allAudiosButton {
  /*display: block;*/
  display: none;
}

.wordsEditor {
  position: absolute;
  z-index: 64;
  width: 560px;
  /*padding: 20px 20px 20px 20px;*/
  background-color: lightgray;
  height: auto;
  border-color: gray;
  border-style: solid;
  top: 6px;
}

.wordsEditor .modal-card-title {
  padding-right: 20px;
}

/*.allAudios {*/
/*  display: none;*/
/*}*/
.allAudios {
  position: absolute;
  z-index: 100;
  width: 512px;
  /*padding: 20px 20px 20px 20px;*/
  background-color: lightgray;
  height: auto;
  border-color: gray;
  border-style: solid;
  top: 6px;
}

.allAudios .modal-card-title {
  padding-right: 20px;
}

.allAudios .delete {
  display: block;
}

.allAudios .player .player-progress {
  width: 237px;
}

.tabs {
  margin-bottom: 0;
}

.tab-content {
  margin: 0;
}

.vue-bulma-tabs .tab-content {
  margin: 0;
}

.urls {
  margin-top: 10px;
  height: 119px;
}

.urls.more_3_items {
  overflow-y: scroll;
}

.urls.more_3_items .urlForAudio i.remove_audio_item,
.urls.more_3_items .urlForAudio i.remove_param {
  margin-right: 15px;
}

.start-node .urls {
  height: 137px;
}

.urlForAudio {
  margin-top: 8px;
  /*width: 90%;*/
}

.urlForAudio input {
  height: 2em;
  font-size: 12px;
}

.urlForAudio input.url {
  display: inline;
  width: 94%;
}

.urlForAudio input.param {
  max-width: 400px;
  min-width: 30%;
  width: 50%;
}

.urlForAudio i {
  display: inline;
  height: 100%;
  font-size: 2em;
}

.urlForAudio i.remove_audio_item,
.urlForAudio i.remove_param {
  color: palevioletred;
  float: right;
}

.urlForAudio i.remove_audio_item:hover,
.urlForAudio i.remove_param:hover {
  color: mediumvioletred;
}

.singleItem .remove_audio_item {
  display: none;
}

.add_url,
.add_param {
  margin-top: 5px;
}

.tabs-content .tab-content {
  display: none;
}

.tabs-content .tab-content.is-active {
  display: block;
}

.tab-content.inputUrls {
  max-height: 137px;
  overflow-y: scroll;
}

.start-node.answer_shell .tabs-content .tab-content.uploadFile {
  height: 137px;
}

.start-node.answer_shell.medium .tabs-content .tab-content.uploadFile {
  height: 117px;
}

.answer_shell.medium .tabs-content .tab-content.uploadFile {
  height: 66px;
}

.answer_shell.medium .tabs-content .tab-content.uploadFile .uploadFromFileDiv {
  padding-top: 13px;
}

.tabs-content .tab-content.uploadFile {
  height: 129px;
}

.tabs-content .tab-content.uploadFile .uploadFromFileDiv {
  text-align: center;
  vertical-align: middle;
  padding-top: 54px;
}

.tabs-content .tab-content.uploadFile .uploadFromFileDiv .is-delete {
  margin-left: 16px;
}

.tabs a {
  padding-bottom: 0;
}

label.isSilence {
  margin-right: 16px;
}

.silence_or_illegibly {
  margin-right: 16px;
}

.searchStrategyDiv {
  float: right;
  /*margin-top:-8px;*/
  font-size: 0.66rem;
}

.start-node .size_more_2.searchStrategyDiv {
  /*margin-top:-23px;*/
}

.medium .searchStrategyDiv,
.small .searchStrategyDiv {
  display: none;
}

.audio_item {
  margin-top: 1px;
  margin-bottom: 3px;
}

input.stateValue {
  display: inline-block;
  min-width: 128px;
  max-width: 256px;
  width: 40%;
  margin-top: -8px;
  /*float:right;*/
}

input.stateQuestion {
  margin-top: 20px;
}

.start-node input.stateQuestion {
  margin-top: 0;
}

.answer_shell.medium .answer .generate_audio_controls .generate_audio_control,
.answer_shell.small .answer .generate_audio_controls .generate_audio_control {
  display: none;
}

.answer_shell.medium .answer .answerWords,
.answer_shell.small .answer .answerWords {
  display: none;
}

.answer_shell.medium .answer textarea {
  height: 56px;
  min-height: 56px;
  resize: none;
}

.answer_shell.medium .answer .vue-codemirror .CodeMirror-wrap {
  height: 56px;
  min-height: 56px;
}

.answer_shell.medium .answer .urls {
  height: 56px;
}

.answer_shell.small .answer .tabs {
  display: none;
}

.answer_shell.small .answer .tabs-content {
  display: none;
}

.answer_shell.small .answer .answerOptionEdit {
  display: none;
}

.answer_shell.small .answer .title .answerTitle {
  max-width: 96px;
  overflow-x: hidden;
  padding-right: 4px;
  display: inline-block;
}

.answer_shell.small .answer .title .windowButtons {
  display: inline-block;
}

.playSourceConfig {
  position: absolute;
  z-index: 3001;
  padding: 8px 8px 8px 8px;
  background-color: lightgray;
  height: auto;
  border-color: gray;
  bottom: 22px;
  right: 26px;
}

.playSourceConfig .value,
.playSourceConfig .key {
  padding: 2px;
  vertical-align: middle;
}

.playSourceConfig input,
.playSourceConfig select {
  width: 128px;
  max-width: 128px;
}

.playSourceConfig .modal-card {
  width: 400px;
}

.playSourceConfig .modal-card-head {
  padding: 10px;
}

.playSourceConfig .modal-card .table {
  margin-bottom: 0;
}

.empty button.audioConfig {
  display: none;
}

.wordsEditor .addForAll {
  margin: 0;
}

.wordsEditor {
  overflow-y: scroll;
  max-height: 512px;
}

.value {
  margin-bottom: 16px;
}

.value .is-block {
  margin-top: 10px;
}
</style>

<style>
.vue-codemirror .CodeMirror-wrap {
  height: 82px;
}
</style>





// WEBPACK FOOTER //
// UniversalAnswer.vue?327c3014